import { transform } from 'ol/proj';
import { correctDegreeAngle } from './unithelper';
import { httpRequest, httpRequestWithProgress } from './httpRequest';
import GeomodImageWMS from '../sources/GeomodImageWMS';
import GeomodTileWMS from '../sources/GeomodTileWMS';

export default class Request {
  constructor(options = {}) {
    this.map = options.map;

    this.projection_ = this.map.getView().getProjection();
    this.requestProjection_ = options.dataProjection || 'EPSG:4326';
    this.format = 'application/json';
  }

  getBaseUrlSerivce_(service) {
    let baseSource = this.map.getInitialLayerGroup().getVisibleLayerBase().getSource();
    // Requetage get feature info en cas de layerBase avec une source XYZ
    if (!baseSource.getUrls) {
      const groupLayer = this.map.getInitialLayerGroup().getLayersArray();
      for (const lay of groupLayer) {
        if (lay.getSource() instanceof GeomodImageWMS || lay.getSource() instanceof GeomodTileWMS) {
          baseSource = lay.getSource();
          break;
        }
      }
    }
    return baseSource.getUrls()[0].replace(/wms$/g, service);
  }

  addQueries_(base, params) {
    const queries = [];
    for (const paramKey in params) {
      if (params[paramKey] !== undefined) {
        queries.push(`${paramKey}=${params[paramKey]}`);
      }
    }
    return `${base}?${queries.join('&')}`;
  }

  getUrl_(serivceName, params) {
    return this.addQueries_(this.getBaseUrlSerivce_(serivceName), params);
  }

  updateViewProjection() {
    this.projection_ = this.map.getView().getProjection();
  }

  updateRequestProjection(projection) {
    this.requestProjection_ = projection;
  }

  async getfeatureinfo_request(coordinate, requestedLayers) {
    const group = this.map.getInitialLayerGroup();
    let queryLayers;
    if (requestedLayers) {
      queryLayers = requestedLayers;
    } else {
      queryLayers = group.getVisibleLayerNameList();
    }
    let baseLayer = group.getVisibleLayerBase();
    // Requetage get feature info en cas de layerBase avec une source XYZ
    if (!baseLayer.getSource().getFeatureInfoUrl) {
      const groupLayer = requestedLayers || group.getLayers().getArray();
      for (const lay of groupLayer) {
        if (lay.getSource && lay.getSource().getFeatureInfoUrl) {
          baseLayer = lay;
          break;
        }
      }
    }
    const url = baseLayer.getSource()
      .getFeatureInfoUrl(
        coordinate,
        this.map.getView().getResolution(),
        this.projection_,
        {
          INFO_FORMAT: this.format,
          QUERY_LAYERS: queryLayers.join(),
        },
      );

    const res = await httpRequest(url, { method: 'GET' }, true, true);
    return res
  }

  async getalert_request(options) {
    const length = options.length < 0 ? 0 : options.length;
    const heading = correctDegreeAngle(options.heading);
    const radius = correctDegreeAngle(options.radius);
    const safetyContour = options.safetyContour < 0 ? 0 : options.safetyContour;
    let tmp;
    for (const c of options.coordinates) {
      tmp = c[0];
      c[0] = c[1];
      c[1] = tmp;
    }

    const params = {
      SERVICE: 'WRA',
      REQUEST: 'GetAlert',
      LENGTH: length,
      RADIUS: radius,
      HEADING: heading,
      SAFETY_CONTOUR: safetyContour,
      COORDS: options.coordinates.join(),
      INFO_FORMAT: this.format,
    };

    const alertUrl = options.url.replace(/wms$/g, 'alert');
    const url = this.addQueries_(alertUrl, params)
    const res = await httpRequest(url, { method: 'GET' }, true, true);
    return res;
  }

  async getalert_postRequest(contours, alertPolygon) {
    const url = this.getBaseUrlSerivce_('alert')
    const body = {
      safetyContour: contours,
      alertPolygon
    }
    return await httpRequest(url, { method: 'POST', body }, true, true);
  }

  async getfeaturewfs_request(options, source) {
    let coord;
    if (options.coordinates) {
      coord = transform(options.coordinates, this.projection_, this.requestProjection_); //options.coordinates; // 
    } else {
      coord = [undefined, undefined];
    }

    let bbox = options.bbox || this.map.getView().calculateExtent(this.map.getSize());
    const c1 = transform([bbox[0], bbox[1]], this.projection_, this.requestProjection_);
    const c2 = transform([bbox[2], bbox[3]], this.projection_, this.requestProjection_);
    bbox = [c1[1], c1[0], c2[1], c2[0]];
    const length = options.length < 0 ? 0 : options.length;
    const params = {
      FeatureType: options.featureType,
      PropertyName: options.propertyName,
      PropertyValue: options.propertyValue,
      FOID: options.featureId,
      INFO_FORMAT: this.format,
      BBOX: bbox,
      SRS: this.requestProjection_,
      LENGTH: length,
      LAT: coord[1],
      LONG: coord[0],
    };

    if (source) {
      source.updateParams({
        ...source.getParams(), ...params, SRS2: params.SRS, BBOX2: params.BBOX,
      });
    }
    const wfsUrl = options.url.replace(/wms$/g, 'wfs');
    const url = this.addQueries_(wfsUrl, { ...params, SERVICE: 'WFS', REQUEST: 'GetFeature' })
    const res = await httpRequest(url, { method: 'GET' }, true, true);
    return res;
  }

  async addfeaturewfs_request(featureCollection, files, onProgress) {
    const formData = new FormData();
    formData.append('featureCollection', JSON.stringify(featureCollection));
    for (const fileName in files) {
      formData.append(fileName, files[fileName]);
    }
    return httpRequestWithProgress(this.getUrl_('wfs'), {
      body: formData,
      method: 'POST',
    }, true, onProgress);
  }
}
